import { useId } from "react";

export const VectorMark = ({ className = "h-9 w-9" }) => {
  const id = useId();
  return (
    <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id={`vm-${id}`} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#0B4A8F" />
          <stop offset="1" stopColor="#2FA8E0" />
        </linearGradient>
      </defs>
      <path d="M13 22 L27 47 L33.5 33 L40 47 L54 22" stroke={`url(#vm-${id})`} strokeWidth="6" strokeLinecap="square" strokeLinejoin="miter" fill="none" />
      <path d="M13 22 L27 47 L33.5 33" stroke="#00F0FF" strokeOpacity="0.35" strokeWidth="6" fill="none" strokeLinecap="square" strokeLinejoin="miter" />
      <path d="M40 24 L51 13" stroke="#00F0FF" strokeWidth="4.5" />
      <path d="M43 12 H52 V21" stroke="#00F0FF" strokeWidth="4.5" fill="none" />
    </svg>
  );
};

export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3 select-none">
      <VectorMark className="h-8 w-8 shrink-0" />
      {!compact && (
        <span className="leading-none">
          <span className="block font-display font-extrabold tracking-[0.22em] text-[15px] text-ink">VECTOR</span>
          <span className="mt-1 block font-mono text-[8px] tracking-[0.34em] text-slate-500">GROWTH &amp; ADVISORY</span>
        </span>
      )}
    </span>
  );
}
